import translations from './generated-translations.json'
import type { SupportedLocale } from '../types/simulation'

export type GeneratedCatalogName = 'ui' | 'auth' | 'paywall' | 'video' | 'studio' | 'create' | 'information'

export function translatedCatalog<T>(
  locale: Exclude<SupportedLocale, 'en' | 'tr'>,
  catalog: GeneratedCatalogName,
  fallback: T,
): T {
  const localePack = (translations as Record<string, Record<string, unknown>>)[locale]
  return (localePack?.[catalog] as T | undefined) ?? fallback
}
